import { passkeyService } from '@egw/auth'
import { type FC } from 'react'
import { VerifyPhoneLinkJoint, VerifyPhoneOtpJoint } from '../../../components'

export const VerifyPhonePage: FC = () => {
  const isMobile = passkeyService.getIsMobile()

  if (!isMobile) {
    return <VerifyPhoneOtpJoint />
  }

  return <VerifyPhoneLinkJoint />
}
